import React, { Suspense, useEffect } from 'react'
import { BrowserRouter as Router, useLocation } from 'react-router-dom'
import CustomRoutes from './routes'
import Loader from 'components/ui-kit/Loader/index'
import { sendMessageOutsideIframe } from 'utils/game.utils'

const GameFrameRouteSync = () => {
  const { pathname, search, hash } = useLocation()

  useEffect(() => {
    if (window.parent === window) return
    sendMessageOutsideIframe('GAME_LOCATION', { href: window.location.href })
  }, [pathname, search, hash])

  return null
}

const Routes = () => (
  <Router>
    <GameFrameRouteSync />
    <Suspense fallback={<Loader />}>
      <div className='flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden'>
        <CustomRoutes />
      </div>
    </Suspense>
  </Router>
)

export default Routes
